import React, { useMemo } from 'react';
import { Dropdown, Tag } from 'tea-component';
import AccountList  from '../AccountList'; 
import useLanguage from '@op/hooks/useLanguage';
import './index.scss';
import ChannelAccountItem from '../ChannelAccountItem';
import { AccountOption, getAccountList } from '../../../utils';

export default function AccountFormSelect({
  options,
  onChange,
  value,
}: {
  options: AccountOption[];
  onChange: (accounts: string[]) => void;
  value: string[];
}) {
  const { formatMessage } = useLanguage();
  const renderList = useMemo(() => {
    return getAccountList(options, value);
  }, [value]);

  return (
    <Dropdown
      trigger="click"
      className="dbo-account-form-select-wrapper"
      clickClose={false}
      button={
        <div className="dbo-account-form-input">
          {renderList.length === 0 && (
            <div className="dbo-placeholder-text">
              {formatMessage({ id: 'Please select' })}
            </div>
          )}
          {renderList.map((item) => (
            <Tag
              key={item.value}
              onClose={(event) => {
                event.stopPropagation();
                onChange(value.filter((it) => it !== item.value));
              }}
            >
              <ChannelAccountItem
                item={item}
              ></ChannelAccountItem> 
            </Tag>
          ))}
        </div>
      }
      size="m"
      matchButtonWidth
      appearance="button"
    >
      <AccountList
        onChange={onChange}
        options={options}
        defaultValue={value}
      ></AccountList>
    </Dropdown>
  );
}
